"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _componentsBase = require("@telus-uds/components-base");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// Passes React Native-oriented system props through UDS Progress
const [selectProps, selectedSystemPropTypes] = (0, _componentsBase.selectSystemProps)([_componentsBase.a11yProps, _componentsBase.viewProps]);
const {
  Bar: ProgressBarBase
} = _componentsBase.Progress;
const Gradient = /*#__PURE__*/_styledComponents.default.div.attrs({
  'data-testid': 'ProgressBar-Gradient'
}).withConfig({
  displayName: "ProgressBar__Gradient",
  componentId: "components-web__sc-1vmzyq5-0"
})(_ref => {
  let {
    gradient: {
      angle,
      stops,
      type
    },
    borderRadius,
    shadow
  } = _ref;
  return {
    height: '100%',
    width: '100%',
    background: `${type}-gradient(${angle}deg, ${stops[0].color}, ${stops[1].color})`,
    borderRadius,
    ...(0, _componentsBase.applyShadowToken)(shadow)
  };
});

/**
 * The `ProgressBar` is a visual representation of linear progression.
 * It provides simple but important information at a quick glance.
 * This is a  Web-specific progress bar.
 *
 * ## Component API
 *
 * Use props and tokens from the base ProgressBar component. The difference is that the
 * `gradient` is being used here to provide gradient filling.
 *
 */

const ProgressBar = /*#__PURE__*/_react.default.forwardRef((_ref2, ref) => {
  let {
    percentage,
    tokens,
    variant,
    offset,
    ...rest
  } = _ref2;
  const themeTokens = (0, _componentsBase.useThemeTokens)('ProgressBar', tokens, variant);
  const selectedProps = selectProps(rest);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(ProgressBarBase, {
    percentage: percentage,
    tokens: tokens,
    variant: variant,
    ref: ref,
    offset: offset,
    ...selectedProps,
    children: themeTokens.gradient && /*#__PURE__*/(0, _jsxRuntime.jsx)(Gradient, {
      ...themeTokens
    })
  });
});
ProgressBar.displayName = 'ProgressBar';
ProgressBar.propTypes = {
  ...selectedSystemPropTypes,
  /**
   * Percentage of completion.
   */
  percentage: _propTypes.default.number,
  /**
   * ProgressBar tokens.
   */
  tokens: (0, _componentsBase.getTokensPropType)('ProgressBar'),
  /**
   * ProgressBar variant.
   */
  variant: _componentsBase.variantProp.propType,
  /**
   * Offset position.
   */
  offset: _propTypes.default.shape({
    items: _propTypes.default.number,
    current: _propTypes.default.number
  })
};
var _default = exports.default = ProgressBar;